var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41634 13.3334L3.58301 16.6667L6.91634 15.8334L16.5713 6.17841C16.8838 5.86586 17.0593 5.44201 17.0593 5.00007C17.0593 4.55813 16.8838 4.13429 16.5713 3.82174L16.428 3.67841C16.1155 3.36596 15.6916 3.19043 15.2497 3.19043C14.8077 3.19043 14.3839 3.36596 14.0713 3.67841L4.41634 13.3334Z",
    stroke: "#056AEC",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41634 13.3335L3.58301 16.6668L6.91634 15.8335L15.2497 7.50012L12.7497 5.00012L4.41634 13.3335Z",
    fill: "#056AEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7497 5.00012L15.2497 7.50012M11.083 16.6668H17.7497",
    stroke: "#056AEC",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/editicon.c4896e8d35a1c48544427d7e6df7b36e.svg";
export { ForwardRef as ReactComponent };